<template>
  <VWidget :title="$t('Group')">
    <div slot="widget-content">
      <v-layout
        wrap
        row
      >
        <v-flex xs12>
          <div slot="widget-content">
            <v-autocomplete
              v-model="customer.groups"
              :items="groups"
              :label="$t('Customer Group')"
              item-text="name"
              item-value="id"
              outline
              return-object
              multiple
            />
          </div>
        </v-flex>
      </v-layout>
    </div>
  </VWidget>
</template>

<script>
export default {
  name: 'CustomerGroup',

  props: {
    customer: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      groups: []
    }
  },

  async mounted () {
    this.groups = await this.$http.make('customer:group').get()
  }
}
</script>
